const SECOND_MS = 1000;
const MINUTE_SECONDS = 60;
const HOUR_SECONDS = MINUTE_SECONDS * 60;
const DAY_SECONDS = HOUR_SECONDS * 24;
const MONTH_SECONDS = DAY_SECONDS * 30;
const YEAR_SECONDS = DAY_SECONDS * 365;

interface TimeUnit {
  readonly seconds: number;
  readonly label: string;
}

const TIME_UNITS: readonly TimeUnit[] = [
  { seconds: YEAR_SECONDS, label: 'year' },
  { seconds: MONTH_SECONDS, label: 'month' },
  { seconds: DAY_SECONDS, label: 'day' },
  { seconds: HOUR_SECONDS, label: 'hour' },
  { seconds: MINUTE_SECONDS, label: 'minute' },
];

export function formatTimeAgo(
  epochMs: number,
  nowMs: number = Date.now(),
): string {
  const diffSeconds = Math.max(0, Math.floor((nowMs - epochMs) / SECOND_MS));

  const unit = TIME_UNITS.find((candidate) => diffSeconds >= candidate.seconds);
  if (!unit) {
    return 'Just now';
  }

  const value = Math.floor(diffSeconds / unit.seconds);
  return `${value} ${unit.label}${value === 1 ? '' : 's'} ago`;
}
